<template>
  <v-container>
    <h3 class="display-3">{{ title ? title : 'Message Center' }}</h3>

    <v-divider class="mt-2"></v-divider>
    <span class="subheading" v-if="!isAuthed">
      Sorry, message center is not available without login.
      <br />

    </span>


    <v-card v-if="isAuthed" :loading="loading">



      <v-card-text>
        <v-data-table :headers="headers" :items="messages" class="elevation-1"                 
        :pagination.sync="options" :total-items="totalMessageCount"        
        :loading="loading" :items-per-page="itemsPerPage">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.Id }}</td>
            <td>{{ props.item.Title }}</td>
            <td>
              <v-chip :color="iconColor[props.item.Status]">
                <v-icon>
                  {{ statusIcons[props.item.Status]  }}
                </v-icon>
              {{ statusText[props.item.Status] ? statusText[props.item.Status] : props.item.Status }}
              </v-chip>
            </td>
            <td>{{ formatDateTime(props.item.CreateDateTime, {
              format: formats.prettyDateTimeFormat, excludeUtcText: true
            }) }}</td>
            <td>
              <ul v-for="l in props.item.Details" :key="l">
                <li v-html="l" @click.prevent="navigateToFile">

                </li>
              </ul>
            </td>
          </template>
        </v-data-table>

      </v-card-text>

      <v-card-actions>
        <v-btn @click="getMessageData" color="primary" large style="margin: 0" class="mb-2" v-bind:loading="loading">
          <v-icon class="mr-1">refresh</v-icon>Refresh
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import MomentUtil from './mixins/MomentUtil'
import {
  prettyDateTimeFormat,
} from '@/components/mixins/MomentUtil'
import { createNamespacedHelpers } from 'vuex'



const { mapGetters } = createNamespacedHelpers('authenticate')
const messages = createNamespacedHelpers('messages')
export default {
  components: {},
  mixins: [MomentUtil],
  props: {
    title: {
      type: String,
      default: 'Message Center',
    },
  },
  data() {
    return {
      itemsPerPage: 10,
      loading: false,      
      options: {        
        rowsPerPage: 10,
      },
      formats: {
        prettyDateTimeFormat,
      },      
      
      headers: [
        {
          text: 'Id',
          align: 'left',
          sortable: false,
          value: 'Id',
        },
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'Title',
        },
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'Status',
        },
        {
          text: 'Create Time',
          align: 'left',
          sortable: false,
          value: 'CreateDateTime',
        },
        {
          text: 'Details',
          align: 'left',
          sortable: false,
          value: 'Details',
        },
      ],
      statusIcons: {
        'initialized': 'mdi-clock-outline',
        'in-progress': 'mdi-progress-check',
        'completed': 'mdi-check-circle-outline',
        'failed': 'mdi-alert-circle-outline',
      },
      statusText: {
        'initialized': 'Initialized',
        'in-progress': 'In Progress',
        'completed': 'Completed',
        'failed': 'Failed',
      },
      iconColor: {
        'initialized': 'blue',
        'in-progress': 'orange',
        'completed': 'green',
        'failed': 'red',
      },
      statusClasses: {
        'initialized': 'status-initialized',
        'in-progress': 'status-in-progress',
        'completed': 'status-completed',
        'failed': 'status-failed',
      },
    }
  },
  computed: {
    ...mapGetters(['isAuthed']),
    ...messages.mapGetters(['messages', 'totalMessageCount']),
  },
  watch: {
    options: {
      handler () {
        console.log(this.options)
        var that = this
        that.loading = true
        this.getMessageData().then(() => {          
          that.loading = false
        })
      },
      deep: true,
    },
  },  
  methods: {
    ...messages.mapActions(['getMessages']),
    async getMessageData() {      
      await this.getMessages(this.options)      
    },
    getClass(status) {
      if (status == 'Info') {
        return 'primary'
      } else if (status == 'Warning') {
        return 'warning'
      } else {
        return 'error'
      }
    },
    navigateToFile(e) {
      console.log(e)
      if (e.srcElement.href) {
        var startIndex = (e.srcElement.protocol + '//' + e.srcElement.host).length
        var path = e.srcElement.href.substring(startIndex)
        this.$router.push(path)
      }
    },



  },
  async mounted() {
    
    //await this.getMessageData()

  },

}
</script>

<style scoped>
.job-status-span {
  color: #ffff
}

.job-item {
  margin: 8px 0;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.job-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.status-initialized {
  background-color: #e3f2fd;
  /* Light blue */
  border-left: 4px solid #2196f3;
  /* Blue */
}

.status-in-progress {
  background-color: #fff3e0;
  /* Light orange */
  border-left: 4px solid #ff9800;
  /* Orange */
}

.status-completed {
  background-color: #e8f5e9;
  /* Light green */
  border-left: 4px solid #4caf50;
  /* Green */
}

.status-failed {
  background-color: #ffebee;
  /* Light red */
  border-left: 4px solid #f44336;
  /* Red */
}

.v-icon {
  margin-right: 16px;
}
</style>